<template>
  <label
    class="company-status-toggle"
    v-tooltip="tooltipText"
    @click.stop
  >
    <input
      type="checkbox"
      :checked="isEnabled"
      @click.prevent="$emit('request-toggle', { company, action: pendingAction })"
    >
    <span class="slider"></span>
  </label>
</template>

<script>
  import { COMPANY_STATUS } from '@/utils/companyStatus'

  export default {
    name: 'CompanyStatusToggle',
    props: {
      company: { required: true, type: Object }
    },
    computed: {
      isEnabled() {
        return Number(this.company.entityStatusId) !== COMPANY_STATUS.DISABLED
      },
      pendingAction() {
        return this.isEnabled ? 'disable' : 'enable'
      },
      tooltipText() {
        return this.isEnabled ? 'Inativar empresa' : 'Reativar empresa'
      }
    }
  }
</script>

<style scoped lang="scss">
  .company-status-toggle {
    position: relative;
    display: inline-block;
    width: 40px;
    height: 22px;
    margin: 0;
    vertical-align: middle;
    cursor: pointer;

    input {
      opacity: 0;
      width: 0;
      height: 0;
    }

    .slider {
      position: absolute;
      cursor: pointer;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: var(--border-color, #ccc);
      transition: .3s;
      border-radius: 22px;
    }

    .slider:before {
      position: absolute;
      content: "";
      height: 16px;
      width: 16px;
      left: 3px;
      bottom: 3px;
      background-color: white;
      transition: .3s;
      border-radius: 50%;
    }

    input:checked + .slider {
      background-color: var(--primary-color, #1f7be8);
    }

    input:checked + .slider:before {
      transform: translateX(18px);
    }
  }
</style>
